export default "__VITE_ASSET__D4Q8DpX9__"